import PropTypes from 'prop-types';

import RichText from '../../../../Core/RichText';

import { Card, Header, Body } from './styles';

const RedemptionCard = ({ data }) => {
  if (!data) return null;

  const { heading, bodyCopy, backgroundColor } = data;

  return (
    <Card $backgroundColor={backgroundColor}>
      <Header>{heading && <RichText document={heading} />}</Header>
      <Body>{bodyCopy && <RichText document={bodyCopy} />}</Body>
    </Card>
  );
};

RedemptionCard.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default RedemptionCard;
